import(/* webpackMode: "eager", webpackExports: ["AnimatedNavbar"] */ "/root/tekyerde-frontend/app/components/layout/animatedNavbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumb"] */ "/root/tekyerde-frontend/app/components/layout/breadcrumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/root/tekyerde-frontend/app/components/layout/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteMetadata"] */ "/root/tekyerde-frontend/app/components/layout/site-metadata.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/tekyerde-frontend/app/hooks/use-scroll.tsx");
;
import(/* webpackMode: "eager" */ "/root/tekyerde-frontend/node_modules/next/font/google/target.css?{\"path\":\"app/(commerce)/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/root/tekyerde-frontend/node_modules/react-hot-toast/dist/index.mjs");
